<template>
</template>

<style lang="scss" scoped>
</style>

<script>
export default {
  props: ['public'],
  data: function () {
    return {
      isMounted: false,
      tree: [],
      macro: null,
      family: null,
      micro: null,
      categories: null,
      articles: null,
      catmicro: null,
      selectedMacro: "",
      currentFamilyTree: null,
      currentMicroFam: [],
      currentColors: [],
      currentMacroFam: null,


    };
  },

  mounted() {
    this.loadMacro();
  },

  methods: {

    //metodi per aprire e chiudere sezioni

    closeModal: function () {
      this.$emit('closeMe')
    },

    /*toggleFamily: function (id) {
      let family = $("#" + id);
      family.children(".wrap-m").toggle();
      family.toggleClass("selected-f");
    },*/
    /* toggleMicro: function (id) {
       let microfamily = $("#" + id);
       microfamily.children(".categs").toggle();
       microfamily.children("img.plus").toggleClass("hide");
       microfamily.children("img.minus").toggleClass("show");
       microfamily.children("img.minus").toggleClass("hide");
     },
     //metodi per caricare tutta l'alberatura
     loadColors: function (codcat) {
       let listaColori = $(".lista-colori:hidden");
       let checkbox = $("#" + codcat);
       if (listaColori) {
         listaColori.show();
       } else {
         listaColori.hide();
       }
       axios({
         method: "get",
         url: window.location.origin + "/data/get-family",
         params: {
           cod: codcat,
           type: "colori_f",
         },
       })
           .then((result) => {
             if (checkbox.prop("checked")) {
               // se selezionato
               result.data.family.forEach((item, i) => {
                 var trovato = this.currentColors.find(function (obj, i) {
                   return obj.code === item.cod_colore;
                 });
                 if (trovato) {
                   let index = this.currentColors.findIndex(function (el) {
                     return el.code === item.cod_colore;
                   });
                   this.currentColors[index].count++;
                 } else {
                   this.currentColors.push({
                     code: item.cod_colore,
                     descrizione: item.color.descrizione,
                     count: 1,
                   });
                 }
               });
             } else {
               //se deselezionato
               result.data.family.forEach((item, i) => {
                 var trovato = this.currentColors.find(function (obj, i) {
                   return obj.code === item.cod_colore;
                 });
                 if (trovato) {
                   let index = this.currentColors.findIndex(function (el) {
                     return el.code === item.cod_colore;
                   });
                   this.currentColors[index].count--;
                 }
               });
             }
             this.currentColors = this.currentColors.filter((el) => el.count > 0);
           })
           .catch((err) => {
             this.$store.commit("add_message", {
               type: "error",
               message: err.response.data.message,
             });
           });
     },*/

    loadMacro: function () {
      axios({
        method: "get",
        url: window.location.origin + "/data/get-family",
        params: {
          type: "filter-m",
          public: !!(this.public),
        },
      })
          .then((result) => {
            let macro = result.data.family;
            let tutto = [];
            //console.log('loadmacro: ', result.data.family)
            macro.forEach((item, index) => {
              let key = item.codice;
              this.loadFamily(item.codice, function (res) {
                tutto.push({
                  code: item.codice,
                  descrizione: item.descrizione,
                  ordinamento: item.ordinamento,
                  famiglie: res,
                });
              });
            });
            setTimeout(()=>{
              tutto = _.orderBy(tutto, 'ordinamento', 'asc')
              this.$emit('treePass', tutto);
            }, 600)





          })
          .catch((err) => {
            console.log(err)
            // this.$store.commit("add_message", {
            //   type: "error",
            //   message: err.response.data.message,
            // });
          });
    },
    loadFamily: function (macrofam, callback) {
      axios({
        method: "get",
        url: window.location.origin + "/data/get-family",
        params: {
          cod: macrofam,
          type: "filter-f",
          public: !!(this.public),
        },
      })
          .then((result) => {
            let famiglie = result.data.family;
            let tutto_f = [];
            //console.log(result.data.family)
            famiglie.forEach((item) => {
              if (item.microfamily.length > 0) {
                this.loadMicro(item.codice, function (res) {
                  tutto_f.push({
                    code: item.codice,
                    descrizione: item.descrizione,
                    microfamiglie: res,
                  });
                  //console.log(item.codice, res)
                });
              } else {
                this.loadCategoriesNoMicro(item.codice, function (res) {
                  tutto_f.push({
                    code: item.codice,
                    descrizione: item.descrizione,
                    microfamiglie: null,
                    categorie: res,
                  });
                });
              }
            });

            callback(tutto_f);
          })
          .catch((err) => {
            this.$store.commit("add_message", {
              type: "error",
              message: err.response.data.message,
            });
          });
    },
    loadMicro: function (family, callback) {
      axios({
        method: "get",
        url: window.location.origin + "/data/get-family",
        params: {
          cod: family,
          type: "filter-micro",
        },
      })
          .then((result) => {
            let microfamilies = result.data.family;
            let tutto_micro = [];

            if (microfamilies.length > 0) {
              microfamilies.forEach((el) => {
                this.loadCategories(el.codice, function (res) {
                  if (res[0] !== null) {
                    tutto_micro.push({
                      code: el.codice,
                      descrizione: el.descrizione,
                      microfamily: true,
                      categorie: res,
                    });
                  }
                });
              });
              //console.log(family, tutto_micro)
              callback(tutto_micro);
            }
          })
          .catch((err) => {
            this.$store.commit("add_message", {
              type: "error",
              message: err.response.data.message,
            });
          });
    },
    loadCategories: function (microfam, callback) {
      axios({
        method: "get",
        url: window.location.origin + "/data/get-family",
        params: {
          cod: microfam,
          type: "filter-categories",
        },
      })
          .then((result) => {
            let microfamilies = result.data.family;
            let tutto_c = [];

            if (microfamilies.length > 0) {
              microfamilies.forEach((el) => {
                tutto_c.push({
                  code: el.cod_categoria,
                  descrizione: el.category.descrizione,
                  ordinamento: el.category.ordinamento
                });
              });
            } else {
              tutto_c.push(null);
            }
            tutto_c = _.orderBy(tutto_c, 'ordinamento', 'asc')
            callback(tutto_c);
          })
          .catch((err) => {
            this.$store.commit("add_message", {
              type: "error",
              message: err.response.data.message,
            });
          });
    },
    loadCategoriesNoMicro: function (fam, callback) {
      axios({
        method: "get",
        url: window.location.origin + "/data/get-family",
        params: {
          cod: fam,
          type: "filter-categories-nomicro",
        },
      })
          .then((result) => {
            let families = result.data.family;
            let tutto_c = [];

            if (families.length > 0) {
              // console.log(families);
              families.forEach((el) => {
                tutto_c.push({
                  code: el.cod_categoria,
                  descrizione: el.category.descrizione,
                  ordinamento: el.category.ordinamento
                });
              });
            }
            this.getFamilies(sessionStorage.macrofam)
            tutto_c = _.orderBy(tutto_c, 'ordinamento', 'asc')
            callback(tutto_c);
          })
          .catch((err) => {
            console.log(err);
            this.$store.commit("add_message", {
              type: "error",
              message: err.response.data.message,
            });
          });
    },
    //metodo per selezionare la famiglia in base alla macrofamiglia
    getFamilies: function (codemacro) {

      this.tree.forEach((item) => {

        if (item.code === codemacro) {
          this.currentFamilyTree = item;
        }
      });

    },
  },
};
</script>

